import React, { useState } from "react";
import ProfileWrapper from "../profileWrapper/ProfileWrapper";
import styles from "./PersonalInfo.module.scss";
import { formatDateTime } from "component/molecules/Table/TableComponents/factory/factory";
import { usePost } from "hooks/usePost";
import { userEndpoints } from "hooks/endpoints";
import UserImage from "component/molecules/new-user/userImage/UserImage";
import ConfirmationModal from "component/hoc/success-modal/ConfirmationModal";
import SvgWithBranding from "component/hoc/branding/withBrandingColor.hoc";

const PersonalInfo = ({ user, refetchUser }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const fields = [
    { label: "Username", value: user?.authUser?.username },
    { label: "Role", value: user?.authUser?.roleName },
    { label: "Mobile", value: user?.authUser?.mobile },
    { label: "Email", value: user?.authUser?.displayEmail },
    { label: "Phone", value: user?.authUser?.phone },
    { label: "Department", value: user?.authUser?.department },
  ];
  const { mutate: Delete, isPending } = usePost();
  const handleDelete = () => {
    Delete(
      {
        method: "Delete",
        url: userEndpoints?.deleteUser(user?.authUser?.userId),
      },
      {
        onSuccess: () => {
          refetchUser();
        },
      }
    );
  };
  const handleCloseModal = () => {
    setIsDeleteModalOpen(false);
  };
  return (
    <ProfileWrapper
      title='Personal information'
      edit
      id={user?.authUser?.userId}
    >
      <div className={styles.cont}>
        <div className={styles.headerSub}>
          <UserImage
            userImage={user?.userImage?.userImage}
            edit
            refetch={refetchUser}
          />

          <div className={styles["name-cont"]}>
            <h3>
              {user?.authUser?.firstName + " " + user?.authUser?.lastName}
            </h3>
            <p>Role Name :{user?.authUser?.roleName || "_"}</p>
            <p>@{user?.authUser?.username || "_"}</p>
          </div>
        </div>

        <div className={styles["calender-cont"]}>
          <div className={styles["details"]}>
            <SvgWithBranding type='calender' />
            <span>Joined - </span>
          </div>

          <div className={styles["details"]}>
            <SvgWithBranding type='logIn' />
            <span>Last Login: {formatDateTime(user?.authUser?.lastLogin)}</span>
          </div>
        </div>
      </div>

      <div className={styles.details}>
        {fields.map((field, index) => (
          <div key={index} className={styles.subDetails}>
            <h3>{field.label || "_"}</h3>
            <p>{field.value || "_"}</p>
          </div>
        ))}
      </div>
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleDelete}
        closeOnSubmit={true}
        onApproveButton={{ text: "delete" }}
        text={`Deleting ${
          user?.authUser?.firstName + " " + user?.authUser?.lastName
        }`}
        subText='Will remove all their data, including associated files and permissions. Proceed?'
        type='Delete'
        isLoading={isPending}
      />
    </ProfileWrapper>
  );
};

export default PersonalInfo;
